import { Button } from '@mui/material';
import { useBlockingRouter } from '../../../hooks/useBlockingRouter';
import React from 'react';
import MuiModal, { MuiModalProps, MuiModalVariants } from '../MuiModal';

type MuiPayToModalProps = Pick<
	MuiModalProps['muiModalProps'],
	'open' | 'onClose'
>;

const MuiPayToModal: React.FC<MuiPayToModalProps> = ( { open, onClose } ) => {
	const Router = useBlockingRouter();
	return (
		<MuiModal
			variant={ MuiModalVariants.textAlignCenter }
			muiModalProps={ {
				open,
				onClose,
				slotProps: {
					paper: {
						'data-cy': 'payto-modal',
					},
				},
			} }
			title='Not so fast'
			description='We need to know where to deposit your money. Add a Pay To account in your wallet so you can get paid.'
			controls={
				<form
					onSubmit={ ( e ) => {
						e.preventDefault();
						e.stopPropagation();
						onClose?.( e, 'closeIcon' );
						Router.push( '/wallet?payto=add' );
					} }
				>
					<Button autoFocus id='pay-to-btn' type='submit'>
						Add Account
					</Button>
				</form>
			}
		/>
	);
};

export default MuiPayToModal;
